/*eslint-disable*/
import React, { Suspense } from "react";
import { withRouter } from "react-router-dom";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { Tab } from "semantic-ui-react";
import Sumary from "./Components/Sumary/Sumary";
import Events from "./Components/Events/Events";
import Comments from "./Components/Comments/Comments";
import Documents from "../Components/Documents";
// import Loader from './../../Global/Loader/index'
import moment from "moment";

import axios from "axios";
import { Services } from "./Services";

// reactstrap components
import { Card, Col, CardHeader, CardTitle } from "reactstrap";

class ShipmentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataDoc: [],
      id: props.match.params.id,
      allSteps: [],
      loaderMap: false,
      ShipmentType: '',
      commentsData: [
        {
          ComType: "Tipo 1",
          ComTypeId: 1,
          Comment: "RR Magic Shiping",
          CommentId: 90,
          Date: "2020-01-29",
          Module: "Prueba RR",
          ModuleId: 1,
          RowId: 861,
          UpdateBy: "API",
        },
        {
          ComType: "Tipo 2",
          ComTypeId: 1,
          Comment: "Comentario de prueba",
          CommentId: 73,
          Date: "2019-06-20",
          Module: "Comentario",
          ModuleId: 1,
          RowId: 861,
          UpdateBy: "API",
        },
        {
          ComType: "Tipo 3",
          ComTypeId: 1,
          Comment: "Comentario de prueba",
          CommentId: 73,
          Date: "2019-07-02",
          Module: "Comentario",
          ModuleId: 1,
          RowId: 861,
          UpdateBy: "API",
        },
      ],
      catalogsData: [
        {
          ComTypeId: 1,
          ModuleId: 1,
          ComType: "Supplier Follow Up",
          value: 1,
          label: "Supplier Follow Up",
        },
        {
          ComTypeId: 2,
          ModuleId: 1,
          ComType: "Order Quality",
          value: 2,
          label: "Order Quality",
        },
        {
          ComTypeId: 3,
          ModuleId: 1,
          ComType: "Order Quantities",
          value: 3,
          label: "Order Quantities",
        },
        {
          ComTypeId: 10,
          ModuleId: 1,
          ComType: "Other",
          value: 10,
          label: "Other",
        },
      ],
      steps: [
        {
          label: "Booking Request",
          value: "",
          id: 1,
          completed: false,
          order: 1,
          middleStep: "",
        },
        {
          label: "Booking Confirmation",
          value: "",
          id: 2,
          completed: false,
          order: 2,
          idStep: "",
          middleStep: "",
        },
        {
          label: "ATD",
          value: "",
          id: 7,
          completed: false,
          order: 3,
          middle: false,
          idStep: "",
          middleStep: "",
        },
        {
          label: "ATA",
          value: "",
          id: 9,
          completed: false,
          order: 4,
          idStep: "step4",
          middleStep: "",
        },
        {
          label: "Docs Release",
          value: "",
          id: 10,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
        },
        {
          label: `Delivery at Destination `,
          value: "",
          id: 11,
          completed: false,
          order: 6,
          idStep: "step6",
          middleStep: "",
        },
      ],
      timeLineTerrestre: [
        {
          label: "Booking Confirmation",
          value: "",
          id: 2,
          completed: false,
          order: 1,
          idStep: "",
          middleStep: "",
        },
        {
          label: "Pick-up & Docs Received",
          value: "",
          id: 17,
          completed: false,
          order: 2,
          middle: false,
          idStep: "",
          middleStep: "",
        },
        {
          label: "Unstuffing & Warehouse Entry",
          value: "",
          id: 19,
          completed: false,
          order: 3,
          idStep: "step4",
          middleStep: "",
        },
        {
          label: "Taxes Payment",
          value: "",
          id: 12,
          completed: false,
          order: 4,
          idStep: "step5",
          middleStep: "",
        },
        {
          label: `Border Crossing Date`,
          value: "",
          id: 24,
          completed: false,
          order: 5,
          idStep: "step6",
          middleStep: "",
        },
        {
          label: `ATA to Final Destination`,
          value: "",
          id: 27,
          completed: false,
          order: 6,
          idStep: "step6",
          middleStep: "",
        },
      ],
    };
  }

  componentDidMount = () => {
    this.getShipmentsForId();
    this.getDocumentsForId();
    // this.getEvents();
  };

  getEvents = () => {
    const { steps, timeLineTerrestre, id, ShipmentType } = this.state;
    let moduleId = 1;
    axios
      .get(`${Services.Get_Events_General.path}events/all/${moduleId}/${id}`)
      .then((response) => {
        var newSteps = ShipmentType !== 'TERRESTRE' ? steps : timeLineTerrestre;
        let dataEvents = response.data.data;
        var findNext = false;
        newSteps.map((f) => {
          dataEvents.map((e) => {
            if (e.EventDescriptionId === f.id) {
              findNext = true;
              f.value = e.EventDate;
              if (e.InTimeLine === "1") {
                f.completed = true;
              } else {
                findNext = false;
              }
            } else {
              findNext = false;
            }
            if (findNext) {
              f.completed = true;
            }
            return e;
          });
          return f;
        });
        newSteps.sort(function (a, b) {
          return b.order - a.order;
        });
        let findTrue = false;
        newSteps.map((e) => {
          if (e.completed) {
            findTrue = true;
          }
          if (findTrue) {
            e.completed = true;
          }
          return e;
        });
        newSteps.sort(function (a, b) {
          return a.order - b.order;
        });
        this.setState({ steps: newSteps, allSteps: dataEvents }, () => { });
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  getDocumentsForId = () => {
    axios
      .get(
        `${Services.Get_DocumentsId.path}Documents/DocumentsId/${this.state.id}`
      )
      .then((success) => {
        let Docs = success.data.data;
        let newData = [];
        Docs.map((e) => {
          let obj = {
            Name: e.NameDocumentHouse,
            Type: e.Type,
            CreationDate: e.CreationDateDocument,
            CreateBy: e.CreateBy,
            URL: e.URL,
          };
          newData.push(obj);
          return e;
        });

        this.setState({
          dataDoc: newData,
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getShipmentsForId = () => {
    axios
      .get(
        `${Services.Get_ShipmentId.path}shipments/dataShipments/${this.state.id}`
      )
      .then((success) => {
        let commentsData = [];
        let data = {
          ComType: "",
          ComTypeId: 1,
          Comment: success.data.data.DataShipment[0].Observations,
          CommentId: "",
          Date: success.data.data.DataShipment[0].Observations
            ? success.data.data.DataShipment[0].ShipmentDate
            : "",
          Module: "Comentario",
          ModuleId: 1,
          RowId: "",
          UpdateBy: "API",
        };
        commentsData.push(data);
        this.setState({
          commentsData,
          ShipmentType: success.data.data.DataShipment[0].ModoTransporte

        }, () => { this.getEvents() });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  render() {
    return (
      <>
        <ContentWrapper>
          <div className="content-heading">
            <i className="fas fa-globe mr-2"></i>
            <b>Shipments Details</b>
          </div>
          <div>
            <Tab
              menu={{ secondary: true }}
              panes={[
                {
                  menuItem: "Summary",
                  render: () => (
                    <Suspense fallback={<div>Loading...</div>}>
                      <Sumary id={this.state.id} steps={this.state.steps} />
                    </Suspense>
                  ),
                },
                {
                  menuItem: "Events",
                  render: () => (
                    <Suspense fallback={<div>Loading...</div>}>
                      <Events
                        cliente={this.state.cliente}
                        NIT={this.state.NIT}
                        Grupo={this.state.Grupo}
                        DoEmbarque={this.state.DoEmbarque}
                        HBL_HAWB={this.state.HBL_HAWB}
                        Estatus={this.state.Estatus}
                        allSteps={this.state.allSteps}
                        steps={this.state.steps}
                      />{" "}
                    </Suspense>
                  ),
                },
                {
                  menuItem: "Comments",
                  render: () => <Comments data={this.state.commentsData} />,
                },
                this.props._rolId !== '4' ?
                  {
                    menuItem: "Documents",
                    render: () => (
                      <div>
                        <Documents
                          rolId={12}
                          shipment=""
                          shipmentDataPlane=""
                          dataDoc={this.state.dataDoc}
                        />
                      </div>
                    ),
                  } : '',
              ]}
            />
          </div>
        </ContentWrapper>
      </>
    );
  }
}

export default withRouter(ShipmentDetails);
